import styled from 'styled-components';

export const LimitedTimeContainer = styled.div`
  border: 0.5px solid var(--way-colors-borderColor);
  padding: 16px;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.5;
  @media (max-width: 768px) {
    margin-top: 32px;
  }
`;
